var exports = {
  "kL": "container__DQE0a3",
  "pA": "tokenText__E-hHsX",
  "Sh": "token__Au4Z9t",
  "ds": "compactContainer__-cXGYI",
  "fv": "multiContainer__v5sul3",
  "yL": "compactValueContainer__hLxlbx",
};

module.exports = exports;
